import moment from 'moment';

export const formatDates = (filters) => ({
  ...filters,
  date_from: moment(filters.date_from).format('YYYY-MM-DD'),
  date_to: moment(filters.date_to).format('YYYY-MM-DD'),
});

export const handleApiError = (error, enqueueSnackbar) => {
  if (enqueueSnackbar) {
    enqueueSnackbar('Failed to update user!', {
      variant: 'error',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      autoHideDuration: 3000,
    });
  }
  return error.toString();
};
